import React,{useState,useEffect} from 'react';
import Axios from 'axios';
import LoaderCircle from '../ui-elements/LoaderCircle';

const EditNote=({webToken,noteId,noteTitle,noteContent,modalFunc,refreshFunc,isNotesModal})=>{
    const [noteData,setNoteData]=useState({title:noteTitle,content:noteContent});
    const [isSubmitDisabled, setIsSubmitDisabled]=useState(true);
    const [validationMessage, setValidationMessage]=useState("");
    const [isPostingNote,setIsPostingNote]=useState(false);

    const checkAllValidFields = () => {
        let validationMessage = "";
    
        // Check if the title is empty
        if (noteData.title === "") {
            validationMessage = "Title is required.";
        }
        // Check if the content is empty
        else if (noteData.content === "") {
            validationMessage = "Content is required.";
        }
        // Check if the content length is less than or equal to 10 characters
        else if (noteData.content.length <= 10) {
            validationMessage = "Content must be longer than 10 characters.";
        }
        // Check if the title and content are the same as the previous values
        else if (noteData.title === noteTitle && noteData.content === noteContent) {
            validationMessage = "No changes detected. Please modify the title or content.";
        }
    
        // If there is a validation message, disable the submit button and show the message
        if (validationMessage !== "") {
            setIsSubmitDisabled(true);
            setValidationMessage(validationMessage); // Assume you have a state or method to display this message
        } else {
            setIsSubmitDisabled(false);
            setValidationMessage(""); // Clear the message if everything is valid
        }
    };

    const doSubmit=()=>{
        event.preventDefault();
        setIsSubmitDisabled(true);
        setIsPostingNote(true);
        Axios.post(`${alimAPIBaseURI}rpc/update_alim_note`, {noteid:noteId, notetitle:noteData.title, notecontent:noteData.content},{headers: {"Content-Type": "application/json","Authorization":`bearer ${webToken}`}}).then((data)=>{
            console.log(data);
            modalFunc(false);
            refreshFunc(1);
        }).catch((error)=>{
            console.log(error);
            modalFunc(false);
            showAlert("Something went wrong.", "warn");
        });
    }

    useEffect(()=>{
        checkAllValidFields();
    },[noteData])

    return(
        <>
            <h2 className="mb-8">Edit Note</h2>
            <form className='grid grid-cols-3 gap-3' method='post'>
                <div className="col-span-3 relative">
                    <label htmlFor="note-title" className="text-white/[.75] bg-deep-blue px-1 absolute -top-0.5 left-3 text-sm font-thin">
                        Note Title
                    </label>
                    <input required id="note-title" type="text" name="note-title" placeholder="Enter note title" className={`h-14 mt-2 ${isNotesModal==="1"?`dark:bg-light-blue`:`dark:bg-deep-blue`} bg-light-blue/10  w-full flex border border-light-blue dark:border-dark-grey-input py-1.5 px-3 text-gray-900 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 alim-input-text-color-style rounded`} defaultValue={noteData.title} onChange={(e)=>{setNoteData({...noteData,title:e.target.value});}}/>
                </div>
                <div className="col-span-3 relative">
                    <label htmlFor="note-content" className="text-white/[.75] bg-deep-blue px-1 absolute -top-0.5 left-3 text-sm font-thin">
                        Your Notes
                    </label>
                    <textarea required id="note-content" type="text" name="note-content" placeholder="Enter notes" className={`h-14 mt-2 bg-light-blue/10 ${isNotesModal==="1"?`dark:bg-light-blue`:`dark:bg-deep-blue`} w-full flex border border-light-blue dark:border-dark-grey-input py-1.5 px-3 text-gray-900 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 alim-input-text-color-style rounded h-64 resize-none`} defaultValue={noteData.content} onChange={(e)=>{setNoteData({...noteData,content:e.target.value});}} minLength="8"/>
                    {
                        validationMessage!==""&&<p className='text-deep-red my-2'>{validationMessage}</p>
                    }
                </div>
                <div className={`col-span-3 flex flex-col justify-between ${isPostingNote?``:`items-center`} pt-4 gap-4 relative w-[170px]`}>
                {
                    isPostingNote?
                        <LoaderCircle/>
                    :
                        <input type='submit' className={`w-full py-3 bg-deep-red rounded text-white ${isSubmitDisabled?`opacity-50`:"red-button-hover-style cursor-pointer"}`} disabled={isSubmitDisabled} onClick={()=>{doSubmit()}} value={"Save changes"}/>
                }
                </div>
            </form>
        </>
        
    )
}

export default EditNote;